import { CookieManager } from "@repo/auth-sdk";

export const ACCESS_TOKEN_KEY = "ACCESS_TOKEN";
export const REFRESH_TOKEN_KEY = "REFRESH_TOKEN";

export const getAccessToken = () =>
  localStorage.getItem(ACCESS_TOKEN_KEY) || CookieManager.getAccessToken();

export const setAccessToken = (token: string) =>
  localStorage.setItem(ACCESS_TOKEN_KEY, `Bearer ${token}`);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const setRefreshToken = (token: string) =>
  localStorage.setItem(REFRESH_TOKEN_KEY, token);

export const removeAccessAndRefreshTokens = () => {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  // An API 401 must clear the cross-portal auth cookie too. Otherwise a page
  // refresh can restore the already-expired token and create a redirect loop.
  CookieManager.clearAuthTokens();
};
